<template>
  <a-card>
    <span slot="title"><a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
      Request Guarantee</span>
    <div slot="extra">
    </div>

    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step v-if="stepRuleDtl" title="Details" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1" :class="steps[current].content == 'Detail' ? 'padding-remove border-none' : ''">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="steps[current].content != 'Approval'" type="primary" @click="next">Next</a-button>
        <a-button v-if="steps[current].content == 'Approval'" type="primary" :loading="loading.submit"
          @click="validate">Save</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import Information from "./steps/Information.vue";
import Detail from "./steps/Detail.vue";
import Approval from "./steps/Persetujuan.vue";
import moment from "moment";
import nanoid from "nanoid";
export default {
  name: "create-requestBidbond",
  props: ["id", "type"],
  components: {
    Information,
    Detail,
    Approval,
  },
  data() {
    return {
      current: 0,
      mode: "Create",
      loading: {
        submit: false,
      },
      dataProcessed: {
        information: {},
      },
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "Detail",
          content: "Detail",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      stepRuleDtl: true,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDateTimeStandartFormat",
      "getStandartFormatDate",
    ]),
    tipe() {
      let output;
      if (this.type == 'revisi') {
        output = 'edit'
      } else if (this.type == 'revisiwf') {
        output = 'revisi'
      }

      return output
    },
    stepProps: function () {
      let result = null;
      if (this.steps[this.current].content === "Information") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
          id: this.id
        };
      } else if (this.steps[this.current].content === "Detail") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
          id: this.id
        };
      } else if (this.steps[this.current].content === "Approval") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
          id: this.id
        };
      }
      return result;
    },
    stepRef: function () {
      let result = null;
      if (this.steps[this.current].content === "Information") {
        result = "refInformation";
      } else if (this.steps[this.current].content === "Detail") {
        result = "refDetail";
      } else {
        result = "refApproval";
      }
      return result;
    },
  },
  created() {
    // this.$store.commit("setInitialFinance");
    if (this.id) {
      this.mode = "Edit";
      //   this.$store.commit("setPageMode", "Edit");
      // } else {
      //   this.mode = "Create";
      //   this.$store.commit("setPageMode", "Create");
    }
  },
  methods: {
    moment,
    fetch() {

      if (this.id) {
        this.mode === "Edit";
        this.$store
          .dispatch("getRevbidbondReq", { auth: this.getAuth, payload: this.id })
          .then((res) => {
            this.dataProcessed.information = {
              form: {
                date: moment(res.hdr[0].create_dt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                location: res.hdr[0].location,
                projectreceive: res.hdr[0].recieve_project,
                contractperson: res.hdr[0].contact_person,
                projectname: res.hdr[0].name_project,
                funding: res.hdr[0].funding,
                nominal: res.hdr[0].nominal,
                duedate: {
                  [0]: moment(res.hdr[0].start_dt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                  [1]: moment(res.hdr[0].end_dt, 'YYYY-MM-DD').format('YYYY-MM-DD')
                },
                note: res.hdr[0].keterangan,
                type: res.hdr[0].type_fund,
                user_am: res.hdr[0].user_am,
                nameobligee: res.hdr[0].obligee_nm,
                addressobligee: res.hdr[0].obligee_address,
                categori: res.hdr[0].category,
              },
              attachment: {

              }
            };

            this.dataProcessed.detail = res.dtl;

            let typefile = res.hdr[0].file_nm.substr(res.hdr[0].file_nm.lastIndexOf("."));

            if (typefile == ".xls") {
              typefile = "data:application/vnd.ms-excel;base64,";
            } else if (typefile == ".xlsx") {
              typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            } else if (typefile == ".doc") {
              typefile = "data:application/msword;base64,";
            } else if (typefile == ".docx") {
              typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
            } else if (typefile == ".pdf") {
              typefile = "data:application/pdf;base64,";
            } else if (typefile == ".jpeg" || typefile == ".jpg") {
              typefile = "data:image/jpeg;base64,";
            } else if (typefile == ".png") {
              typefile = "data:image/png;base64,";
            }

            var file = this.dataURLtoFile(
              typefile + res.hdr[0].files,
              res.hdr[0].file_nm
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.exist = true;
            file.url = this.$serviceUrl + res.hdr[0].file_url;
            this.dataProcessed.information.attachment = [file];

            if (res.hdr[0].type_fund == "0") {
              this.stepRuleDtl = false;
            } else {
              this.stepRuleDtl = true;
            }

            this.$store.commit("setDataInfoForm", this.dataProcessed.information);
            this.$store.commit("setAllDataDtlForm", this.dataProcessed.detail);
            this.$refs.refInformation.initialData();
          });
      }
    },
    next() {
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
      } else {
        this.$refs.refApproval.handleRef();
      }
    },
    prev() {
      if (this.steps[this.current].content === "Detail") {
        // if (!this.stepRuleDtl) {
        //   this.current = this.current - 1;
        // } else {
        this.current--;
        //}
      } else if (this.steps[this.current].content === "Approval") {
        if (!this.stepRuleDtl) {
          this.current--;
        }
        this.current--;
      } else {
        this.current--;
      }
    },
    validate() {
      // if(this.stepRuleDtl){
      //   this.$refs.refDetail.handleRef();
      // }else{
      //   this.$refs.ref.handleRef();
      //   this.submit();
      // }
      this.$refs.refApproval.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Information") {
        this.dataProcessed.information = value;
        this.$store.commit("setDataInfoForm", value);
        this.getApprovalList(this.dataProcessed.information);
      } else if (this.steps[this.current].content === "Detail") {
        this.dataProcessed.detail = value;
        this.current++;
      } else if (this.steps[this.current].content === "Approval") {
        this.dataProcessed.information.form['note'] = value.note;
        this.submit();
      }
    },
    submit() {
      this.loading.submit = true;
      let postData = new FormData();

      // Information
      postData.append("tlc", this.getAuth.username);
      postData.append("date_guarantee", moment(this.dataProcessed.information.form.date).format(this.getDateTimeStandartFormat));
      postData.append("location", this.dataProcessed.information.form.location);
      if (this.dataProcessed.information.form.projectreceive)
        postData.append("receiver_project", this.dataProcessed.information.form.projectreceive);
      if (this.dataProcessed.information.form.contractperson)
        postData.append("contact_person", this.dataProcessed.information.form.contractperson);
      if (this.dataProcessed.information.form.projectname)
        postData.append("project_name", this.dataProcessed.information.form.projectname);
      if (this.dataProcessed.information.form.funding)
        postData.append("funding", this.dataProcessed.information.form.funding);
      postData.append("nominal", this.dataProcessed.information.form.nominal ? this.dataProcessed.information.form.nominal : 0);
      postData.append("start_due_date", moment(this.dataProcessed.information.form.duedate[0]).format(this.getDateTimeStandartFormat));
      postData.append("end_due_date", moment(this.dataProcessed.information.form.duedate[1]).format(this.getDateTimeStandartFormat));
      if (this.dataProcessed.information.form.note)
        postData.append("note", this.dataProcessed.information.form.note);
      if (this.dataProcessed.information.form.type)
        postData.append("type", this.dataProcessed.information.form.type);
      if (this.dataProcessed.information.form.user_am != null) {
        postData.append("user_am", this.dataProcessed.information.form.user_am);
      }
      postData.append("upload_file", this.dataProcessed.information.attachment[0]);
      if (this.mode == "Edit") {
        postData.append("bidbond_request_id", this.id);
      }

      postData.append("obligee_name", this.dataProcessed.information.form.nameobligee);
      postData.append("obligee_address", this.dataProcessed.information.form.addressobligee);
      postData.append("category", this.dataProcessed.information.form.categori);

      // Detail
      if (this.stepRuleDtl)
        postData.append("dtl", JSON.stringify(this.dataProcessed.detail));

      this.$store
        .dispatch(this.mode == "Edit" ? "postRevbidbondReq" : "submitBidBondRequest", { auth: this.getAuth, payload: postData })
        .then((res) => {
          if (this.mode == "edit") {
            this.displayMessage("success-edit");
          } else {
            this.displayMessage("success");
          }
          this.$store.commit("clearDataForm");
          this.loading.submit = false;
          this.$router.go(-1);
        })
        .catch((err) => {
          this.displayMessageValue("basic-error", err.response.data.message);
          this.loading.submit = false;
        });

    },
    setstepRulesDtl(value) {
      this.stepRuleDtl = value;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    getApprovalList(val) {
      this.$store
        .dispatch("getapprovalbidbondReq", {
          auth: this.getAuth,
          payload: {
            type: val.form.type,
            user_am: val.form.user_am
          }
        })
        .then((res) => {
          this.dataProcessed.approval = res.data;
          if (!this.stepRuleDtl) {
            this.current++;
          }
          this.current++;
        })
        .catch((err) => {
          this.displayMessageValue("basic-error", err.response.data.message);
          this.loading.submit = true;
        });
    }
  },
  mounted() {
    this.fetch();
    Event.$on("emitBidbondReq", this.valueFromChild);
    Event.$on("setstepRulesDtl", this.setstepRulesDtl);

  },
  beforeDestroy() {
    Event.$off("emitBidbondReq", this.valueFromChild);
    Event.$off("setstepRulesDtl", this.setstepRulesDtl);
  },
};
</script>

<style lang="less">
.border-none {
  border: none;
}
</style>
